import { useQuery } from '@tanstack/react-query';
import {
  PolicyReviewAtRenewalGetRequestParams,
  PolicyReviewAtRenewalGetRequestQuery,
  PolicyReviewAtRenewalGetResponse,
} from '@lio/api-types';
import { useClient } from '@utils/api-client';
import { reviewAtRenewalQueryKeys } from './keys';
import { config } from '@services/config';

const getQueryParams = (params: PolicyReviewAtRenewalGetRequestQuery) => {
  const query = new URLSearchParams();

  const { pageLimit, pageOffset, sort } = params;

  if (pageLimit !== undefined) {
    query.append('pageLimit', String(pageLimit));
  }

  if (pageOffset !== undefined) {
    query.append('pageOffset', String(pageOffset));
  }

  if (sort !== undefined) {
    query.append('sort', sort);
  } else {
    query.append('sort', '-createdAt');
  }

  return query.toString();
};

export const useSearchReviewAtRenewal = ({
  policyId,
  ...queryParams
}: PolicyReviewAtRenewalGetRequestParams & PolicyReviewAtRenewalGetRequestQuery) => {
  const client = useClient();
  const query = getQueryParams(queryParams);
  const queryString = query ? `?${query}` : '';

  const result = useQuery<PolicyReviewAtRenewalGetResponse>({
    queryKey: reviewAtRenewalQueryKeys.searchWithParams(policyId, queryParams),
    queryFn: () =>
      client.get(`policy/${policyId}/review-at-renewal${queryString}`).json<PolicyReviewAtRenewalGetResponse>(),
    enabled: !!policyId,
    ...config,
  });

  return { ...result, reviewAtRenewalItems: result.data };
};
